import View from './view/shape-view'
import Model from './shape-model'

export {
	View,
	Model
}
